import { Box, Heading, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Text, Button, Link } from '@chakra-ui/react'; 
import { renderFaqTextWithLinks } from './faqTextLinks';

const faqs = [ { question: 'What loan products does Swift Credit offer?', 
    answer: `Swift Credit currently offers short-term installment loans. Short-term loans are offered from $500 to $20,000 for eligible borrowers.`, },
    
    { question: 'How do I apply for a loan with Swift Credit?', 
    answer: `Applying is simple:

    1. Complete the online application form.

    2. Submit the required identity and income details.

    3. Review your offer and accept if it fits your needs.

    Once approved, funds are deposited based on your selected product and banking timelines.`, }, 
   
    
    { question: 'How quickly can I receive funds?', 
    answer: `Swift Credit offers near-instant funding. E-transfer are typically sent to your account within one minute of signing. Some smaller banks may take a few hours. For these Banks, deposits before 11 AM PST arrive by 3:30 PM, 11 AM-3:45 PM by 8 PM, and after 3:45 PM or weekends and holidays by 3:30 PM the next business day.`, }, 
   
    { question: 'What are the rates and borrowing costs?', 
    answer: `Rates and borrowing costs are shown before you accept. Current disclosures include installment loans with APR ranges from 19.99% to 30.99%.`, }, 
    
    { question: 'Who is eligible to apply?', 
    answer: `To apply:
• You must be 18 years of age or older.
• You must have an established income that is on Direct Deposit.
• You must have a bank account open and in use for at least 30 days.`, },

    { question: 'How does the referral program work?', 
    answer: `To qualify, you must be a current customer in good standing (or have a loan paid off within the last 3 months). Your referral must be a new customer approved for at least $2,500. After the referred loan is active for 90 days in good standing, both of you receive $100 each by EFT.`, },

    
    { question: 'Can I repay my loan early?', 
    answer: `Yes. Based on our disclosures, installment loans can be paid off at any time with no penalty, and interest applies only up to the payoff date.`, },
]; 
    
export default function FaqSection() {
      return ( 
          <Box id="faq-section" backgroundColor="blackAlpha.100" py={20}> 
            <Box  maxW="800px" mx="auto" py={10} px={4}>
                         <Heading as="h2" size="lg" mb={6} textAlign="center" color="black"> Swift Credit FAQs </Heading> 
             <Accordion allowToggle > 
                {faqs.map((faq, index) => ( 
                    
                    <AccordionItem key={index} border="none" mb={4}> 
                        <AccordionButton _expanded={{ bg: 'white' }} _hover={{ bg: 'gray.100' }} 
                            px={4} py={3} borderRadius="2xl" boxShadow="2xl" backgroundColor="white"> 
                            <Box flex="1" textAlign="left" fontWeight="medium"> {faq.question} </Box> 
                            <AccordionIcon /> 
                        </AccordionButton> 
                        
                        <AccordionPanel px={4} py={2} color="black"> 
                            <Text whiteSpace="pre-line">{renderFaqTextWithLinks(faq.answer)}</Text> 
                        </AccordionPanel> 
                    </AccordionItem> ))} 
            </Accordion> 
            <Box textAlign="center" mt={6}>
                <Link href="/help" _hover={{ textDecoration: 'none' }}>
                    <Button backgroundColor="white" color="black" size="md" borderRadius="2xl" boxShadow="lg" _hover={{ bg: 'gray.100' }}>
                        Search for your questions
                    </Button>
                </Link>
            </Box>
        </Box> 
    </Box> ); }